import { createContext } from 'react'

import { useLayoutProvider } from './hooks/useLayoutProvider'

export type LayoutContextValue = ReturnType<typeof useLayoutProvider>

export const LayoutContext = createContext<LayoutContextValue | undefined>(undefined)
